import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import red from '@material-ui/core/colors/red'
import grey from '@material-ui/core/colors/grey'

import Layout from './components/Layout/Layout';
import LoadableComponent from './components/hoc/LoadableComponent';
import withTimeOut from './components/hoc/withTimeOut';

const AsyncHomePage = LoadableComponent({
    loader: () => import('./components/Home/HomePage')
});

const theme = createMuiTheme({
    palette: {
        primary: red,
        text: grey
    },
    typography: {
        fontFamily: "'Lato', sans-serif",
        fontSize: 16
    }
});

export default () => (
    <MuiThemeProvider theme={theme}>
        <Layout>
            <Switch>
                <Route path="/" component={withTimeOut(AsyncHomePage)} />
            </Switch>
        </Layout>
    </MuiThemeProvider>
);



// WEBPACK FOOTER //
// ./src/App.js